// extracted by mini-css-extract-plugin
module.exports =  {"container":"HNbNwK7","figure":"XF4Lvic","caption":"U5taSrT"};